module.exports = __webpack_public_path__ + "static/img/tdyy1.50f4abd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tdyy1.jpg
// module id = 6It2
// module chunks = 1